<div container="body" [autoClose]="autoClose" ngbDropdown (openChange)="openChange.emit($event)" class="d-inline-block dropdown-submenu" display="dynamic">
    <ca-spinner-circular [size]="40" [color]="'#28b4f5'" *ngIf="isBusy"></ca-spinner-circular>
    <button
        ngbDropdownToggle
        type="button"
        class="btn ca-btn-icon ca-btn-icon-small"
        #tooltip="ngbTooltip"
        placement="auto"
        container="self"
        data-uit="dropdown-submenu-button"
        (click)="toggleTooltip($event)"
        [ngbTooltip]="'GENERAL.MORE' | translate"
        [disabled]="disabled || isBusy"
        [class.is-busy]="isBusy"
    >
        <ca-icon name="three-dots" size="s" class="dots-icon" *ngIf="!isBusy"></ca-icon>
        <ca-icon name="{{ isBusyIcon }}" size="s" class="busy-icon" *ngIf="isBusy"></ca-icon>
    </button>
    <div class="align-items-center" ngbDropdownMenu data-uit="dropdown-menu">
        <ng-content></ng-content>
    </div>
</div>
